import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Picker } from "emoji-mart";
import {
  removeThread,
  setRichText,
  sendTypingIndicator,
} from "../../../actions/ThreadAction";
import { 
  CompositeDecorator, 
  Editor, 
  EditorState, 
  ContentState,
  Modifier, 
  RichUtils, 
  convertToRaw,
  convertFromHTML,
  getDefaultKeyBinding,
  SelectionState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import { OrderedSet } from "immutable";
import "emoji-mart/css/emoji-mart.css";
import "./RichText.css";

const styleMap = {
  MENTION: {
    color: "#2193f3",
    fontWeight: "bold",
  },
};

class RichTextInput extends Component {
  typingTimer = null;
  typingState = false;

  constructor(props) {
    super(props);

    this.state = {
      showPicker: false,
      isFocus: false,
      editTextMessage: "",
      attentionState: false,
      attentionList: [],
      isMentionActive: false,
      attentionIndex: 0,
      attnMember: "",
      allowMention: true,
      editorState: EditorState.createEmpty(),
      prevEditorText: "",
    }

    // this.state = {editorState: EditorState.createEmpty()};
    this.handleKeyCommand = this.handleKeyCommand.bind(this);
    this.richRef = React.createRef();
    this.emojiRef = React.createRef();
    this.buttonRef = React.createRef();
    this.previousState = null;
    
    this.handleClickBox = this.handleClickBox.bind(this);
    this.handleBeforeInput = this.handleBeforeInput.bind(this);
  };

  componentDidMount() {
    const inputField = document.getElementById("editor");
    const width = inputField.offsetWidth;
    inputField.style.maxWidth = width.toString() + "px";

    window.addEventListener("click", this.handleClickBox);
    setTimeout(() => {
      if (this.richRef.current) {
        this.richRef.current.focus();
      }
    }, 0);
  };

  componentDidUpdate(prevProps) {
    if (this.props.richText === "") {
      this.onChange( EditorState.createEmpty() );
      this.setState({
        editTextMessage: "",
        attnMember: "",
        attentionList: [],
        isMentionActive: false,
        allowMention: true,
      });
    }
    if (this.props.editTextMessage !== undefined && 
        this.props.editTextMessage !== "" &&
        this.props.editTextMessage !== this.state.editTextMessage) {
      this.setState({ editTextMessage: this.props.editTextMessage });

      const blocksFromHTML = convertFromHTML(this.props.editTextMessage);
      const newContentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      const newEditorState = EditorState.createWithContent(newContentState);
      this.onChange( newEditorState );
    }
    if (this.props.threadType === "private" && this.state.allowMention !== false) {
      this.setState({
        allowMention: false,
      });
    }
    if (this.props.attnMember === "") return;
    // Only insert if it actually changed and is not empty
    if (prevProps.attnMember !== this.props.attnMember && this.props.attnMember) {
      if (this.props.attnMember === "&&&") {
        // this.cancelMention(true);
        return;
      } else if (this.props.attnMember === "###") {
        this.deleteAllMentions();
      } else {
        this.insertMention(this.props.attnMember);
      }
    }
  };

  componentWillUnmount() {
    window.removeEventListener("click", this.handleClickBox);
    if (this.typingTimer) {
      clearTimeout(this.typingTimer);
      if (this.props.activeThread) {
        this.props.sendTypingIndicator(this.props.activeThread.objectId, false);
      }
    }
  };

  handleClickBox(e) {
    if (
      this.emojiRef.current && !this.emojiRef.current.contains(e.target) &&
      this.buttonRef.current && !this.buttonRef.current.contains(e.target)
    ) {
      this.setState({ showPicker: false });
    }
  };

  onChange = (editorState) => {
    this.setState({ editorState });
    const content = editorState.getCurrentContent();
    const plain = content.getPlainText().trim();
    const newText = content.getPlainText().trim();
    const oldText = this.state.prevEditorText;

    if (plain.length === 1 && oldText.length > 5) {
      // this.props.isTyping({ target: { key: "clear", value: "" } });
      this.setState({
        attentionList: [],
        // isMentionActive: false,
        allowMention: true,
      })
    };

    if (oldText.length > newText.length) {
      this.checkMissingMention(editorState);
    };

    if (plain.length === 0) {
      // this.props.isTyping({ target: { key: "clear", value: "" } });
      this.setState({
        attentionList: [],
        // isMentionActive: false,
        allowMention: true,
        editorState: EditorState.createEmpty(),
      })
    }
    if (this.richRef.current) {
      this.getHtml(editorState);
    }
    this.setState({ prevEditorText: plain });

    if (!this.typingState && newText !== oldText) {
      this.typingState = true;
      this.props.sendTypingIndicator(this.props.activeThread.threadId, true);
    }
    // console.log("typingState", this.typingState)

    clearTimeout(this.typingTimer);

    // Restart timer
    this.typingTimer = setTimeout(() => {
      if (!this.typingState) return;

      // console.log('3 sec past --- false')
      this.typingState = false;
      this.props.sendTypingIndicator(this.props.activeThread.threadId, false);
    }, 3000);
  };

  getHtml = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const rawContent = convertToRaw(contentState);
    const html = this.rawToHtml(rawContent);
    this.props.setRichText(html);

    const blockMap = contentState.getBlocksAsArray();
    const hasNewLine = blockMap.length > 1;

    if (contentState.getPlainText() !== "" && this.state.isMentionActive) {
      let plainText = contentState.getPlainText(); // check if multiple lines
      let fakeTyping = { target: { value: plainText.slice(this.state.attentionIndex) }};

      if (!hasNewLine) {
        this.props.isTyping(fakeTyping);
      }
    } else {
      let fakeTyping = { target: { value: "" }};
      this.props.isTyping(fakeTyping);
    };
  };

  rawToHtml = (raw) => {
    const mentionStyle = 'color:#2193f3;font-weight:bold;';
    let html = '';
    let listOpen = false;
    let currentListType = null;

    raw.blocks.forEach((block) => {
      const text = block.text;
      const ranges = [...block.inlineStyleRanges].sort((a, b) => a.offset - b.offset);

      let inner = '';
      let index = 0;

      while (index < text.length) {
        // Find all styles that apply to this character
        const activeRanges = ranges.filter(
          (r) => index >= r.offset && index < r.offset + r.length
        ).map(r => r.style);

        let charHtml = this.escapeHtml(text[index]);

        // Wrap character in correct tags/styles
        if (activeRanges.length) {
          let openTags = '';
          let closeTags = '';

          activeRanges.forEach(style => {
            switch (style) {
              case 'MENTION':
                openTags += `<span style="${mentionStyle}">`;
                closeTags = `</span>` + closeTags;
                break;
              case 'BOLD':
                openTags += `<strong>`;
                closeTags = `</strong>` + closeTags;
                break;
              case 'ITALIC':
                openTags += `<em>`;
                closeTags = `</em>` + closeTags;
                break;
              case 'UNDERLINE':
                openTags += `<u>`;
                closeTags = `</u>` + closeTags;
                break;
              case 'STRIKETHROUGH':
                openTags += `<s>`;
                closeTags = `</s>` + closeTags;
                break;
              default:
                break;
            }
          });

          charHtml = `${openTags}${charHtml}${closeTags}`;
        }

        inner += charHtml;
        index++;
      }

      // Handle block types (lists)
      if (block.type === 'unordered-list-item' || block.type === 'ordered-list-item') {
        const listTag = block.type === 'unordered-list-item' ? 'ul' : 'ol';
        if (!listOpen || listTag !== currentListType) {
          if (listOpen) html += `</${currentListType}>`;
          html += `<${listTag}>`;
          listOpen = true;
          currentListType = listTag;
        }
        html += `<li>${inner}</li>`;
      } else {
        if (listOpen) {
          html += `</${currentListType}>`;
          listOpen = false;
          currentListType = null;
        }
        html += `<p>${inner}</p>`;
      }
    });

    if (listOpen) html += `</${currentListType}>`;
    return html;
  };

  escapeHtml = (str) =>
    str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

  handleBeforeInput = (chars, editorState) => {
    const { isMentionActive, allowMention } = this.state;
    const selection = editorState.getSelection();
    const content = editorState.getCurrentContent();

    // --- handle "@" ---
    if (chars === "@" && allowMention) {
      // If mention is already active, block extra "@"
      if (isMentionActive) {
        return "handled";
      }

      // Replace or insert depending on selection
      const newContent = selection.isCollapsed()
        ? Modifier.insertText(content, selection, chars, OrderedSet(["MENTION"]))
        : Modifier.replaceText(content, selection, chars, OrderedSet(["MENTION"]));

      const pushed = EditorState.push(editorState, newContent, "insert-characters");
      const withSelection = EditorState.forceSelection(pushed, newContent.getSelectionAfter());

      const anchorIndex = selection.isCollapsed()
        ? content.getPlainText().length
        : selection.getAnchorOffset();

      this.onChange(withSelection);
      this.setState({
        isMentionActive: true,
        attentionIndex: anchorIndex + 1,
      });

      this.props.isTyping({ target: { value: "@" } });
      return "handled";
    }

    // --- detect full selection (Ctrl+A) ---
    const anchorKey = selection.getAnchorKey();
    const focusKey = selection.getFocusKey();
    const firstBlockKey = content.getFirstBlock().getKey();
    const lastBlockKey = content.getLastBlock().getKey();

    const isAllSelected =
      selection.getAnchorOffset() === 0 &&
      selection.getFocusOffset() === content.getBlockForKey(focusKey).getLength() &&
      anchorKey === firstBlockKey &&
      focusKey === lastBlockKey;

    if (isAllSelected) {
      const newContent = Modifier.replaceText(content, selection, chars);
      const newEditorState = EditorState.push(editorState, newContent, "insert-characters");

      this.onChange(EditorState.forceSelection(newEditorState, newContent.getSelectionAfter()));
      return "handled";
    }

    // --- detect highlighted selection (partial or full) ---
    const isHighlightSelected = !selection.isCollapsed();

    if (isHighlightSelected) {
      // console.log("User highlighted some text and typed:", chars);

      const newContent = Modifier.replaceText(content, selection, chars, OrderedSet());
      const newEditorState = EditorState.push(editorState, newContent, "insert-characters");

      this.onChange(EditorState.forceSelection(newEditorState, newContent.getSelectionAfter()));
      this.checkMissingMention(EditorState.forceSelection(newEditorState, newContent.getSelectionAfter()));
      return "handled";
    }

    // --- normal typing (no mention active) ---
    if (!isMentionActive) {
      const newContent = Modifier.insertText(content, selection, chars, OrderedSet());
      const pushed = EditorState.push(editorState, newContent, "insert-characters");
      const withSelection = EditorState.forceSelection(pushed, newContent.getSelectionAfter());
      this.onChange(withSelection);
      return "handled";
    }

    return "not-handled";
  };

  handleReturn = () => {
    // Stop mention on Enter
    this.setState({ isMentionActive: false });
    return "not-handled";
  };

  checkMissingMention = (editorState) => {
    const content = editorState.getCurrentContent();
    const plain = content.getPlainText();
    const missing = this.state.attentionList.filter(item => !plain.includes(item));

    if (missing.length > 0) {
      this.props.isTyping({ target: { key: "deleteMultiple", value: missing }});
    }
  }

  addEmoji = (emoji) => {
    const { editorState } = this.state;
    const currentContent = editorState.getCurrentContent();
    const contentStateWithEmoji = Modifier.insertText(
      currentContent,
      editorState.getSelection(),
      emoji.native
    );
    this.onChange( EditorState.push(editorState, contentStateWithEmoji, "insert-characters") );
  };

  handlePastedText = (text, html) => {
    const newContentState = Modifier.replaceText(
      this.state.editorState.getCurrentContent(),
      this.state.editorState.getSelection(),
      text,
      null,
    );
    this.onChange( EditorState.push(this.state.editorState, newContentState, "insert-characters"));
    return "handled";
  };

  toggleEmojiPicker = () => {
    this.setState((prevState) => ({ showPicker: !prevState.showPicker }));
  };

  toggleInlineStyle = (style) => {
    this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, style));
  };

  toggleBlockType = (style) => {
    this.onChange(RichUtils.toggleBlockType(this.state.editorState, style));
  };

  onEditorFocus = () => {
    this.setState({ isFocused: true });
    this.props.onFocus();
    this.richRef.current.focus();
  };

  onEditorBlur = () => {
    this.setState({ isFocused: false });
  };

  handleKeyCommand(command, editorState) {
    const newState = RichUtils.handleKeyCommand(editorState, command);

    // --- custom mention deletion ---
    if (command === 'delete-mention') {
      const selection = editorState.getSelection();
      if (!selection.isCollapsed()) return 'not-handled';

      const content = editorState.getCurrentContent();
      const blockKey = selection.getStartKey();
      const block = content.getBlockForKey(blockKey);
      const offset = selection.getStartOffset();
      const charList = block.getCharacterList();

      if (offset === 0) return 'not-handled';

      // --- detect if inside a mention span ---
      let start = offset - 1;
      while (
        start >= 0 &&
        charList.get(start) &&
        charList.get(start).getStyle().has('MENTION')
      ) {
        start--;
      }
      start++;
      let end = offset;
      while (
        end < charList.size &&
        charList.get(end) &&
        charList.get(end).getStyle().has('MENTION')
      ) {
        end++;
      }

      const insideMention = offset > start && offset < end;
      if (insideMention) {
        // ⛔ block delete if in the middle
        return 'handled';
      }

      // --- your existing delete-mention logic when at edge ---
      let atIndex = -1;
      for (let i = start; i < offset; i++) {
        if (block.getText().charAt(i) === '@') {
          atIndex = i; // farthest '@'
        }
      }
      const finalStart = atIndex !== -1 ? atIndex : start;

      const removeSelection = SelectionState.createEmpty(blockKey).merge({
        anchorOffset: finalStart,
        focusOffset: offset,
      });

      const newContent = Modifier.removeRange(content, removeSelection, 'backward');
      let newEditorState = EditorState.push(editorState, newContent, 'remove-range');
      newEditorState = EditorState.forceSelection(newEditorState, newContent.getSelectionAfter());

      const removedText = block.getText().slice(finalStart, offset);
      this.props.isTyping({ target: { key: "delete", value: removedText }});

      this.setState(prev => ({
        editorState: newEditorState,
      }), () => {
        if (this.richRef.current) this.richRef.current.focus();
        this.getHtml(newEditorState);
      });

      return 'handled';
    }

    if (command === "split-block" && this.state.isMentionActive) {
      // console.log("Enter pressed!");
      let fakeTyping = { target: { key: "enter", value: "" }};
      this.props.isTyping(fakeTyping);

      this.setState({ isMentionActive: false });
      const { editorState } = this.state;
      const newState = RichUtils.toggleInlineStyle(editorState, "MENTION");
      this.setState({ editorState: newState });

      let plainText = editorState.getCurrentContent().getPlainText();

      return "handled";
    }
    // --- custom tab command ---
    if (command === "insert-3-spaces") {
      const content = editorState.getCurrentContent();
      const selection = editorState.getSelection();

      const newContent = Modifier.insertText(content, selection, "   ");
      const newState = EditorState.push(editorState, newContent, "insert-characters");

      this.onChange(newState);
      return "handled";
    }

    if (newState) {
      this.onChange(newState);
      return "handled";
    }
    return "not-handled";
  };

  isListBlockActive = () => {
    const { editorState } = this.state;
    const contentState = editorState.getCurrentContent();
    const selection = editorState.getSelection();
    const block = contentState.getBlockForKey(selection.getStartKey());
    const blockType = block.getType();

    return blockType === "unordered-list-item" || blockType === "ordered-list-item";
  };

  keyBindingFn = (e) => {
    const { editorState } = this.state;

    if (e.key === "Backspace" || e.key === "Delete") {
      this.onBackspacePressed();

      if (this.state.isMentionActive) return;
      const selection = editorState.getSelection();

      if (!selection.isCollapsed()) {
        this.previousState = editorState;
        return getDefaultKeyBinding(e);
      }

      const offset = selection.getStartOffset();
      if (offset === 0) {
        this.previousState = editorState;
        return getDefaultKeyBinding(e);
      }

      const block = editorState
        .getCurrentContent()
        .getBlockForKey(selection.getStartKey());

      const charMeta = block.getCharacterList().get(offset - 1);
      const hasMentionStyle = !!(charMeta && charMeta.getStyle && charMeta.getStyle().has && charMeta.getStyle().has('MENTION'));

      if (hasMentionStyle) {
        this.previousState = editorState;
        return 'delete-mention';
      }

      // not a mention char — keep previous behavior
      this.previousState = editorState;
      return getDefaultKeyBinding(e);
    }
    if (e.key === "Tab" && this.state.isMentionActive) {
      return "split-block";
    }
    if (e.key === "Tab") {
      e.preventDefault();
      return "insert-3-spaces";
    }
    if (e.key === " " && this.state.isMentionActive) {
      this.cancelMention();
    }
    // capture ctrl + x bind

    return getDefaultKeyBinding(e);
  };

  cancelMention = () => {
    const { editorState } = this.state;
    const content = editorState.getCurrentContent();
    const selection = editorState.getSelection();
    const blockKey = selection.getStartKey();
    const block = content.getBlockForKey(blockKey);
    const offset = selection.getStartOffset();

    const text = block.getText().slice(0, offset);
    const mentionMatch = text.match(/@\S+$/);
    if (!mentionMatch) {
      this.setState({ isMentionActive: false, attnMember: "" });
      return;
    }

    const start = offset - mentionMatch[0].length;
    const end = offset;

    const removeSelection = SelectionState.createEmpty(blockKey).merge({
      anchorOffset: start,
      focusOffset: end,
    });

    let newContent = Modifier.removeRange(content, removeSelection, "backward");

    newContent = Modifier.insertText(
      newContent,
      newContent.getSelectionAfter(),
      mentionMatch[0]
    );

    const newEditorState = EditorState.push(
      editorState,
      newContent,
      "insert-characters"
    );

    this.setState({
      editorState: newEditorState,
      isMentionActive: false,
      attnMember: "",
    });
    this.props.isTyping({ target: { key: " ", value: "" }});
  };

  onBackspacePressed = () => {
    const { editorState } = this.state;
    const contentState = editorState.getCurrentContent();
    const plainText = contentState.getPlainText();
    const lastLetter = plainText.slice(plainText.length - 1);

    if (lastLetter === "@") {
      this.setState({ isMentionActive: false });
      this.props.isTyping({ target: { key: " ", value: "" }});
    }
  }

  onEditorBlur = () => {
    // console.log("OnBlur trigger!");
  }

  insertMention = (mentionText, previousState) => {
    // console.log('mentionText', mentionText)
    const isAdd = mentionText.startsWith("@");
    
    if (mentionText.startsWith("#")) {
      // remove single mention
      let removeMentionText = "@" + mentionText.slice(1);
      removeMentionText = removeMentionText.endsWith("%") ? removeMentionText.slice(0, -1) : removeMentionText;

      this.setState((prevState) => ({
        attentionList: prevState.attentionList.filter(item => item !== removeMentionText)
      }), () => {
        // console.log('attentionList', this.state.attentionList);
      });
      
    } else {
      // ADD multiple members from modal-attention
      if ((mentionText.split("@").length - 1) > 1) {
        const batchMention = mentionText
          .split(/(?=@)/)
          .filter(p => p.startsWith("@"))
          .map(p => p.endsWith("%") ? p.slice(0, -1) : p);

        this.setState((prevState) => ({
          attentionList: [...(prevState.attentionList || []), ...batchMention]
        }), () => {
          //
        });
      } else {
        // ADD single mention
        let newMentionText = isAdd ? mentionText : "@" + mentionText;
        newMentionText = newMentionText.endsWith("%") ? newMentionText.slice(0, -1) : newMentionText;

        this.setState((prevState) => ({
          attentionList: [...(prevState.attentionList || []), newMentionText]
        }), () => {
          //
        });
      }
    }

    // if all members is tagged - block new tagg
    if (mentionText.endsWith("%")) {
      mentionText = mentionText.slice(0, -1); 
      this.setState({ allowMention: false });
    } else {
      this.setState({ allowMention: true });
    }

    const cleanName = mentionText.slice(1);
    
    const { editorState } = this.state;
    const selection = editorState.getSelection();
    const content = editorState.getCurrentContent();
    const anchorKey = selection.getAnchorKey();
    const block = content.getBlockForKey(anchorKey);
    const blockText = block.getText();
    const anchorOffset = selection.getAnchorOffset();

    let newContent = content;

    if (mentionText.startsWith("@")) {
      // ADD tagg name
      const startOffset = anchorOffset;

      const targetRange = selection.merge({
        anchorKey,
        anchorOffset: startOffset,
        focusKey: anchorKey,
        focusOffset: anchorOffset,
      });

      newContent = Modifier.replaceText(
        content,
        targetRange,
        `@${cleanName}`,
        OrderedSet(["MENTION"])
      );

    } else if (mentionText.startsWith("#")) {
      // REMOVE tagg name
      content.getBlocksAsArray().forEach((block) => {
        const text = block.getText();
        const blockKey = block.getKey();
        let match;

        if (text.includes(`@${cleanName}`)) {
          const regex = new RegExp(`@${cleanName}`, "g");
          while ((match = regex.exec(text)) !== null) {
            const start = match.index;
            const end = start + match[0].length;

            const removeRange = selection.merge({
              anchorKey: blockKey,
              anchorOffset: start,
              focusKey: blockKey,
              focusOffset: end,
            });

            newContent = Modifier.replaceText(
              newContent,
              removeRange,
              ""
            );
          }
        }
      });
    } else {
      // TAB auto complete tagg name
      // console.log("TAB key press")
      const block = content.getBlockForKey(anchorKey);
      const blockText = block.getText();

      const lastAt = blockText.lastIndexOf("@", anchorOffset - 1);
      if (lastAt === -1) return;

      const targetRange = selection.merge({
        anchorKey,
        anchorOffset: lastAt,
        focusKey: anchorKey,
        focusOffset: anchorOffset,
      });

      newContent = Modifier.replaceText(
        content,
        targetRange,
        `@${mentionText}`,
        OrderedSet(["MENTION"])
      );
    }

    let newEditorState = EditorState.push(editorState, newContent, "insert-characters");
    newEditorState = EditorState.forceSelection(newEditorState, newContent.getSelectionAfter());
    newEditorState = EditorState.setInlineStyleOverride(newEditorState, OrderedSet());

    this.onChange(newEditorState);
    this.setState({ isMentionActive: false, attnMember: cleanName }, () => {
      if (this.richRef.current) this.richRef.current.focus();
    });
    this.props.isTyping({ target: { key: " ", value: "" }});
  };

  deleteAllMentions = () => {
    const { editorState } = this.state;
    const content = editorState.getCurrentContent();
    const blockMap = content.getBlockMap();

    let newContent = content;

    blockMap.forEach(block => {
      const text = block.getText();
      const charList = block.getCharacterList();
      let start = null;

      for (let i = 0; i < charList.size; i++) {
        const styles = charList.get(i).getStyle();

        if (styles.has("MENTION")) {
          if (start === null) start = i;
        } else if (start !== null) {
          // Found the end of a mention span
          const selection = SelectionState.createEmpty(block.getKey()).merge({
            anchorOffset: start,
            focusOffset: i,
          });

          newContent = Modifier.removeRange(newContent, selection, "backward");
          start = null;
        }
      }

      // If mention runs until the end of block
      if (start !== null) {
        const selection = SelectionState.createEmpty(block.getKey()).merge({
          anchorOffset: start,
          focusOffset: text.length,
        });

        newContent = Modifier.removeRange(newContent, selection, "backward");
      }
    });

    const newEditorState = EditorState.push(editorState, newContent, "remove-range");
    this.setState(({
      editorState: newEditorState,
      isMentionActive: false,
      attentionList: [],
    }), () => {
      // console.log('attentionList', this.state.attentionList);
    });
  };

  handleClick = (e) => {
    // console.log('Editor clicked');
  };

  render() {
    const isListActive = this.isListBlockActive();
    return (
      <div>
        <button 
          data-toggle="tooltip"
          data-placement="top"
          title="Bold"
          onClick={(e) => {
            e.preventDefault();
            this.toggleInlineStyle("BOLD");
          }}>
          <strong>
            B
          </strong>
        </button>&nbsp;
        <button 
          data-toggle="tooltip"
          data-placement="top"
          title="Italic"
          onClick={(e) => {
            e.preventDefault();
            this.toggleInlineStyle("ITALIC");
          }}
          style={{ fontStyle: "italic", fontFamily: "Times New Roman" }}>
            I
        </button>&nbsp;
        <button 
          data-toggle="tooltip"
          data-placement="top"
          title="Underline"
          onClick={(e) => {
            e.preventDefault();
            this.toggleInlineStyle("UNDERLINE");
          }}
          style={{ textDecoration: "underline" }}>
            U
        </button>&nbsp;
        <button 
          data-toggle="tooltip"
          data-placement="top"
          title="Strikethrough"
          onClick={(e) => {
            e.preventDefault();
            this.toggleInlineStyle("STRIKETHROUGH");
          }}
          style={{ textDecoration: "line-through" }}>
            S
        </button>&nbsp;
        <button 
          data-toggle="tooltip"
          data-placement="top"
          title="Unordered list"
          onClick={(e) => {
            e.preventDefault();
            this.toggleBlockType("unordered-list-item");
          }}>
          <i class="fas fa-list fa-sm"></i>
        </button>&nbsp;
        <button 
          data-toggle="tooltip"
          data-placement="top"
          title="Ordered list"
          onClick={(e) => {
            e.preventDefault();
            this.toggleBlockType("ordered-list-item");
          }}>
          <i class="fas fa-list-ol"></i>
        </button>&nbsp;
        <button 
          data-toggle="tooltip"
          data-placement="top"
          title="Select emoji"
          ref={this.buttonRef}
          onClick={(e) => {
            e.preventDefault();
            this.toggleEmojiPicker();
          }}
          >
            😃
        </button>&nbsp;
        {this.state.showPicker && (
          <div 
            ref={this.emojiRef}
            style={{ position: "absolute" }}
          >
            <Picker
              style={{
                position: "absolute",
                // top: "",
                bottom: "0px",
                left: "200px",
              }} 
              onSelect={this.addEmoji}
              title="Pick your emoji"
              emoji="point_up"
            />
          </div>
        )}
        <div 
          id="editor"
          className={`editor-container`}
          onClick={this.onEditorFocus}
          tabIndex={-1}
        >
          <Editor
            editorState={this.state.editorState}
            handleKeyCommand={this.handleKeyCommand}
            onChange={this.onChange}
            ref={this.richRef}
            // onFocus={this.onEditorFocus}
            // isClick={this.props.isClick}
            placeholder={isListActive ? "" : this.props.placeholder}
            handlePastedText={this.handlePastedText}
            keyBindingFn={this.keyBindingFn}
            handleBeforeInput={this.handleBeforeInput}
            // handleReturn={this.handleReturn}
            customStyleMap={styleMap}
            // onBlur={this.onEditorBlur}
            // onFocus={this.onEditoF}
            // onMouseDown={this.handleClick}
          />
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => ({
  richText: state.thread.richText,
});

export default withRouter(
  connect(mapStateToProps, {
    setRichText,
    sendTypingIndicator,
  })(RichTextInput)
);